import { render, staticRenderFns } from "./TodayTask.vue?vue&type=template&id=3f4dd928&scoped=true"
import script from "./TodayTask.vue?vue&type=script&lang=js"
export * from "./TodayTask.vue?vue&type=script&lang=js"
import style0 from "./TodayTask.vue?vue&type=style&index=0&id=3f4dd928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4dd928",
  null
  
)

export default component.exports